import React, { createRef, FC, useEffect, useMemo, useRef, useState } from "react";
import { Button, Form, Selector, SpinLoading, Dialog } from "antd-mobile";
import { sourceLanguageOptions, speakerOptions } from "@/pages/Mobile/Outside/pages/tools/dict";
import { createBrowserHistory } from 'history';
import s from './index.module.scss';
import { Recorder } from "@/utils/Recorder";
import { startRecord, stopRecord, heartTimeout } from '@/api/grt/ai';
import { LeftOutline } from 'antd-mobile-icons';
import { useNavigate, useParams } from "react-router-dom";
import moment from 'moment';
import { cloneDeep } from "lodash";
import '@/assets/font/iconfont.css';
import Utils, { RequestResult } from "@/components/Utils";
import recordPause from '@/assets/images/record-pause.png';
import recordPlay from '@/assets/images/record-play.gif';
import ToastUtils from '@/utils/ToastUtils';
import { fetchCheckCanRecord } from '@/api/tingWu';

type FormDataType = {
    source_language?: string;
    speaker_count?: string;
    target_languages?: string;
    task_id?: string;
    document_name?: string;
};
type RequestResultType = {
    success: boolean;
    msg?: string;
}
type AddRecordRequestResultDataType = {
    TaskId?: string;
    MeetingJoinUrl?: string;
}
type RecordItemType = {
    id?: string;
    index?: number;
    time?: number;
    result?: string;
}

enum RecordStatus {
    START,
    PAUSE,
    LOADING,
    STOP,
    STOP_LOADING
}

enum Type {
    EDIT,
    ADD
}

interface Props {
    type?: Type
}

type AddRecordRequestResultType = { data: AddRecordRequestResultDataType } & RequestResultType;
const Record: FC<Props> = () => {
    const [formData, setFormData] = useState<FormDataType>();
    const [disabled, setDisabled] = useState<boolean>(true);
    const [showPermMsg, setShowPermMsg] = useState<boolean>(true);
    const [started, setStarted] = useState(false);
    const [recordObj, setRecordObj] = useState<Recorder>();
    const [recordStatus, setRecordStatus] = useState<RecordStatus>(RecordStatus.STOP);
    const [msgList, setMsgList] = useState<{ time: number, msg: string }[]>([]);
    const formRef = createRef<any>();
    const recordListRef = useRef<RecordItemType[]>([]);
    const [selectOptions, setSelectOptions] = useState<any[]>([]);
    const [sourceLanguageVal, setSourceLanguageVal] = useState<string>('cn');
    const [speakerVal, setSpeakerVal] = useState<string>('1');
    const [lock, changeLock] = useState(false);
    const [wsUrl, setWsUrl] = useState<string>('');
    const timer = useRef<number | undefined | null>(null);
    const [update, changeUpdate] = useState<number | null>(null);
    const [timeout, updateTimeout] = useState<number>(0);
    const timeoutTimer = useRef<number | undefined | null>(null);
    const img = {
        addTitle_icon: require('@/assets/images/tw/mobile/addTitle_icon.png'),
        recordTipDel_icon: require('@/assets/images/tw/mobile/recordTipDel_icon.png'),
        addrecord_back: require('@/assets/images/tw/mobile/addrecord_back.png'),
        end_icon: require('@/assets/images/tw/mobile/end_icon.png'),
        pause_icon: require('@/assets/images/tw/mobile/pause_icon.png'),
        recording_back: require('@/assets/images/tw/mobile/recording_back.png'),
        play_icon: require('@/assets/images/tw/mobile/play_icon.png'),
        return_icon: require('@/assets/images/tw/mobile/return_icon.png'),
    }
    const navigate = useNavigate();
    const params = useParams();
    const history = createBrowserHistory();
    const scrollView = () => {
        const recordList = document.querySelector('#record-list');
        if (recordList) {
            const last = recordList.lastElementChild;
            if (last) last.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    };
    const recordStartCallback = (payload: { index: number }) => {
        try {
            console.log(payload, "recordStartCallback");
            let recordListClone = cloneDeep(recordListRef.current);
            const index = payload.index;
            if (!recordListClone.find(item => item.index === index)) {
                recordListClone.push(payload);
            }
            recordListRef.current = recordListClone;
            changeUpdate(Math.floor(Math.random() * 10000));
            scrollView();
        } catch (e) {
            console.error(e);
        }
    };
    const startHeartBeatHandle = (task_id: string) => {
        timer.current = window.setInterval(async () => {
            const handle = await heartTimeout({ task_id });
            console.log(handle, 'start Heart Beat Handle Result');
        }, 5000);
    };
    const recordChangeCallback = (payload: { index: number, result: any, time: number, words: any[] }) => {
        try {
            let recordListClone = cloneDeep(recordListRef.current);
            const index = payload.index;
            if (!recordListClone.find(item => item.index === index)) {
                recordListClone.push(payload);
            } else {
                for (const ele of recordListClone) {
                    if (ele.index === index) {
                        for (const eleKey in payload) {
                            if (eleKey === 'time') continue;
                            // @ts-ignore
                            ele[eleKey] = payload[eleKey];
                        }
                    }
                }
            }
            changeUpdate(Math.floor(Math.random() * 10000));
            recordListRef.current = recordListClone;
        } catch (e) {
            console.error(e);
        }
    };
    const recordEndCallback = (payload: { index: number, result: any, time: number, begin_time: number }) => {
        try {
            let recordListClone = cloneDeep(recordListRef.current),
                flag = false;
            for (const item of recordListClone) {
                if (payload.index === item.index && !flag) {
                    item.result = payload.result;
                    item.index = Math.floor(Math.random() * 10000);
                    flag = true;
                }
            }
            changeUpdate(Math.floor(Math.random() * 10000));
            recordListRef.current = recordListClone;
        } catch (e) {
            console.error(e);
        }
    };
    const onErrorCallback = () => {
        ToastUtils.showToast('服务请求发生错误');
        setTimeout(() => {
            stopRecordHandle({ callbackDetail: true });
        }, 200);
    };
    const addRecordRequest = () => {
        changeLock(true);
        //@ts-ignore
        let result: Promise<AddRecordRequestResultType> = startRecord({
            ...formData,
            agent_id: params?.agentId,
            tools_id: params.toolId
        });
        result.then((res) => {
            const { success, data, msg } = res;
            if (success && data.MeetingJoinUrl) {
                const wsUrl = data.MeetingJoinUrl,
                    task_id = data.TaskId,
                    recorder = new Recorder({
                        wsUrl,
                        recordStart: recordStartCallback,
                        recordChange: recordChangeCallback,
                        recordEnd: recordEndCallback,
                        onError: onErrorCallback
                    });
                startHeartBeatHandle(task_id as string);
                recorder.startRecord();
                const cloneForm: FormDataType = cloneDeep(formData || {});
                cloneForm.task_id = task_id;
                setTimeout(() => {
                    setRecordStatus(RecordStatus.START);
                }, 100);
                setWsUrl(wsUrl);
                setFormData(cloneForm);
                setRecordObj(recorder);
                setStarted(true);
            } else ToastUtils.showToast(msg || '服务请求发生错误');
        });
    };
    const onValuesChange = (_change: FormDataType, all: FormDataType) => {
        const newData = Object.assign({}, formData, all);
        setFormData(newData);
    };
    const startRecordHandle = async () => {
        if (disabled) return;
        //@ts-ignore
        fetchCheckCanRecord().then((res: RequestResult & { data: boolean }) => {
            if (res.success && res.data) {
                return ToastUtils.showToast('已经有一个实时录音未停止，请稍等～');
            }
            setRecordStatus(RecordStatus.LOADING);
            addRecordRequest();
        });
    };
    const pauseRecord = () => {
        changeLock(false);
        setRecordStatus(RecordStatus.LOADING);
        setTimeout(() => {
            recordObj?.stopRecord();
            setRecordStatus(RecordStatus.PAUSE);
        }, 1000);
        scrollView();
    };
    const restartRecord = () => {
        changeLock(true);
        const recorder = new Recorder({
            wsUrl,
            recordStart: recordStartCallback,
            recordChange: recordChangeCallback,
            recordEnd: recordEndCallback,
            onError: onErrorCallback
        });
        recorder.startRecord();
        setRecordObj(recorder);
        setRecordStatus(RecordStatus.START);
        scrollView();
    };
    const stopRecordHandle = ({ callbackDetail, callbackList }: { callbackDetail?: boolean, callbackList?: boolean }) => {
        if (recordStatus === RecordStatus.STOP_LOADING) return;
        if (!formData?.task_id) return;

        // 显示确认弹窗
        Dialog.confirm({
            bodyClassName: s['modal-popup-dialog'],
            content: (
                <div style={{ color: '#666666', fontSize: 16, textAlign: 'center', fontWeight: 400 }}>
                    <span style={{ color: '#333', fontWeight: 600,display:'block',marginBottom:'8px' }}>确定结束录音吗?</span>
                    确定结束后，无法继续录音
                </div>
            ),
            confirmText: '结束录音',
            cancelText: '取消',
            onConfirm: () => {
                setRecordStatus(RecordStatus.STOP_LOADING);
                changeLock(false);
                recordObj?.closeMicrophone();
                if (formData?.task_id) stopRecord({ task_id: formData?.task_id }).then((res) => {
                    //@ts-ignore
                    if (res.data && res.success) {
                        clearInterval(timer.current as number);
                        if (callbackDetail) {
                            setTimeout(() => {
                                navigate(`/mobile/o/${params?.agentId}/tools/${params?.toolId}/${res.data}`);
                            }, 1500);
                        }
                        if (callbackList) {
                            setTimeout(() => {
                                navigate(`/mobile/o/${params?.agentId}/tools/${params?.toolId}`);
                            }, 200);
                        }
                    }
                });
                else ToastUtils.showToast('操作失败');
            }
        });
    };
    const updateStatus = () => {
        //@ts-ignore
        navigator.permissions.query({ name: "microphone" }).then((result) => {
            let flag = false;
            if (result.state === "granted") {
                flag = true;
            } else if (result.state === "prompt") {
                flag = false;
                //@ts-ignore
                navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia;
                //@ts-ignore
                navigator.getUserMedia(
                    { audio: true },
                    async (stream: MediaStream) => {
                        const mediaRecorder = new MediaRecorder(stream);
                        mediaRecorder.stop();
                        stream.getTracks().forEach(ele => ele.stop());
                        setDisabled(false);
                    },
                    (error: any) => {
                        setDisabled(true);
                    },
                )
            } else if (result.state === "denied") {
                flag = false;
            }
            setDisabled(!flag);
            result.addEventListener("change", () => {
                if (result.state === "denied" && recordStatus === RecordStatus.START) {
                    ToastUtils.showToast('您当前的浏览器不支持麦克风录音,请开启麦克风权限继续');
                    pauseRecord();
                } else if (result.state !== "denied" && recordStatus === RecordStatus.PAUSE) {
                    ToastUtils.showToast('已恢复麦克风权限，继续录音');
                    restartRecord();
                }
                setDisabled(result.state === "denied");
            });
        });
    };

    /**
     * 播放录音（测试使用）
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const playBackAudio = () => {
        const audio = document.querySelector('#audio');
        if (audio && recordObj?.blobEventData) {
            const blob = new Blob(recordObj?.blobEventData, { type: 'audio/wav' });
            //@ts-ignore
            audio.src = URL.createObjectURL(blob);
            setTimeout(() => {
                //@ts-ignore
                audio.play();
            }, 100);
        }
    };

    /**
     * 下载录音（测试使用）
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const downLoadData = () => {
        if (recordObj?.blobEventData) {
            let a = document.createElement('a');
            a.download = 'record.wav';
            const blob = new Blob(recordObj?.blobEventData, { type: 'audio/wav' });
            //@ts-ignore
            a.href = window.URL.createObjectURL(blob);
            a.click();
        }
    };
    const checkCanRecord = () => {
        //@ts-ignore
        fetchCheckCanRecord().then((res: RequestResult & { data: boolean }) => {
            if (res.success && res.data) {
                ToastUtils.showToast('已经有一个实时录音未停止，请稍等～');
                setTimeout(() => {
                    navigate(`/mobile/o/${params?.agentId}/tools/${params?.toolId}`);
                }, 500);
            }
        });
    };
    const updateTimeHandle = (timeout: number) => {
        const recordStartTime = document.querySelector('.record-start-time');
        if (recordStartTime) {
            recordStartTime.innerHTML = Utils.formatTime(timeout);
        }
    };

    useEffect(() => {
        if (recordListRef.current?.length) {
            const msg_list: any[] = [],
                list = recordListRef.current;
            let index = 0,
                count = 0;
            for (const item of list) {
                if (count > 0 && count % 3 === 0) {
                    index++;
                }
                if (msg_list[index]) {
                    const oldMsg = msg_list[index].msg || '';
                    msg_list[index].msg = oldMsg + item.result;
                } else msg_list.push({ msg: item.result || '', time: item.time || 0 });
                count++;
            }
            setMsgList(msg_list);
            setTimeout(scrollView, 1000);
        }
    }, [update]);
    useEffect(() => {
        if (formRef) {
            const initFormData: FormDataType = Object.assign({}, formData, {
                source_language: 'cn',
                target_languages: 'no',
                speaker_count: '1',
                document_name: moment(new Date()).format('YYYY-MM-DD HH:mm') + ' 记录'
            });
            setFormData(initFormData);
            formRef.current?.setFieldsValue(initFormData);
        }
    }, [formRef.current]);
    useEffect(() => {
        if (timeout >= 24 * 60 * 60) {
            stopRecordHandle({ callbackDetail: true });
            return;
        }
        updateTimeHandle(timeout);
    }, [timeout]);
    useEffect(() => {
        if (recordStatus === RecordStatus.START) {
            timeoutTimer.current = window.setInterval(() => {
                // @ts-ignore
                updateTimeout(prevState => prevState + 1);
            }, 1000);
        } else if (recordStatus === RecordStatus.PAUSE || recordStatus === RecordStatus.STOP || recordStatus !== RecordStatus.STOP_LOADING) {
            updateTimeHandle(timeout);
            clearInterval(timeoutTimer.current as number);
        }
    }, [recordStatus]);
    useEffect(() => {
        let unBlock: any;
        if (lock) {
            // 上锁
            unBlock = history.block(({ location: nextLocation }: { location: any }) => {
                unBlock();
            });
        } else {
            unBlock && unBlock(); // 解锁
        }
    }, [lock]);
    useEffect(() => {
        checkCanRecord();
        updateStatus();
        return () => {
            clearInterval(timer.current as number);
            if (recordStatus !== RecordStatus.STOP && recordStatus !== RecordStatus.STOP_LOADING) stopRecordHandle({ callbackList: true });
        };
    }, []);
    useEffect(() => {
        if (!formData?.source_language) return setSelectOptions([]);
        let resultOptions: any[] = [];
        switch (formData?.source_language) {
            case 'en':
                resultOptions = [{ label: '不翻译', value: 'no' }, { label: '中文', value: 'cn' }, {
                    label: '日语',
                    value: 'ja'
                }];
                break;
            case 'cn':
                resultOptions = [{ label: '不翻译', value: 'no' }, { label: '英语', value: 'en' }, {
                    label: '日语',
                    value: 'ja'
                }];
                break;
            case 'ja':
                resultOptions = [{ label: '不翻译', value: 'no' }, { label: '中文', value: 'cn' }, {
                    label: '英语',
                    value: 'en'
                }];
        }
        return setSelectOptions(resultOptions);
    }, [formData?.source_language]);
    const noPermMsg = useMemo(() => {
        return <div className={s['add-form-no-perm']}>
            <span>麦克风权限未开启，请开启后刷新页面重试</span> <img src={img.recordTipDel_icon} onClick={(e) => { e.stopPropagation(); console.log('点击了关闭'); setShowPermMsg(false); }} /></div>;
    }, [disabled, showPermMsg]);

    const startRecordEle = useMemo(() => {
        return <div className={s['addForm-rg']}>
            <img src={img.addrecord_back} className={s['add-form-img']} />
            <div className={s['addForm-item']}>
                <Form onValuesChange={onValuesChange} ref={formRef} layout="vertical">
                    <Form.Item name="source_language">
                        <div className={s['selector-item-title']}><img src={img.addTitle_icon} />选择音频语言</div>
                        <div className={s['selector-lsit']}>
                            <Selector
                                showCheckMark={false}
                                options={sourceLanguageOptions}
                                value={[sourceLanguageVal]}
                                onChange={(values) => {
                                    if (values.length) {
                                        const newData = Object.assign({}, formData || {});
                                        newData.source_language = values[0];
                                        setFormData(newData);
                                        setSourceLanguageVal(values[0]);
                                    } else {
                                        formRef.current.setFieldsValue({ source_language: sourceLanguageVal });
                                    }
                                }}
                            />
                        </div>
                    </Form.Item>
                    <Form.Item name='target_languages' label='翻译' style={{ display: 'none' }}>
                        <Selector
                            disabled={formData?.source_language === 'yue' || formData?.source_language === 'fspk'}
                            options={selectOptions} />
                    </Form.Item>
                    <Form.Item name='speaker_count'>
                        <div className={s['selector-item-title']}><img src={img.addTitle_icon} />区分发言人</div>
                        <div className={s['selector-lsit']}>
                            <Selector
                                showCheckMark={false}
                                options={speakerOptions}
                                value={[speakerVal]}
                                onChange={(values) => {
                                    if (values.length) {
                                        const newData = Object.assign({}, formData || {});
                                        newData.speaker_count = values[0];
                                        setFormData(newData);
                                        setSpeakerVal(values[0]);
                                    } else {
                                        formRef.current.setFieldsValue({ speaker_count: speakerVal });
                                    }
                                }}
                            />
                        </div>
                    </Form.Item>
                </Form>
                <div className={s['add-form-footer']}>
                    {disabled && showPermMsg ? noPermMsg : ''}
                    <Button
                        key="submit"
                        loading={RecordStatus.LOADING === recordStatus}
                        color="primary"
                        onClick={startRecordHandle}
                        style={{ width: '100%' }}
                        disabled={disabled}
                    >
                        开始录音
                    </Button>
                </div>
            </div>
        </div>;
    }, [started, formData, selectOptions, disabled, showPermMsg]);
    const HeadTitle = () => {
        return <div className={s['ai-content-body-header-title']} onClick={() => callbackHandle()}>
            <div className={s['outlinedBtn']} ><LeftOutline /></div>
            <span className={s['nameText-realTime']}>实时记录</span>
        </div>
    };
    const HeadTitleOther = () => {
        return <div className={s['ai-content-body-headerOther-title']}>
            <div className={s['ai-content-body-headerOther-lf']}>
                <div className={s['outlinedBtnOther']} onClick={() => callbackHandle()}>
                    {/* <img src={img.return_icon} /> */}
                </div>
            <span className={s['nameText']}>{formData?.document_name}</span>
            </div>
            <div className={s['nameTip']}>内容由AI生成，仅供参考</div>
        </div>
    };
    const recordingFooter = useMemo(() => {
        return <div className={s['record-list-footer']}>
            <div className={s['record-list-footer-recording']}>
                
                <div className={s['record-list-footer-recording-time']}>
                    <span
                        className={s['record-list-footer-recording-title']}>{recordStatus === RecordStatus.START ? '录音中' : recordStatus === RecordStatus.PAUSE ? '暂停中' : recordStatus === RecordStatus.STOP ? '已停止' : ''}</span>
                    <div className={s['record-list-footer-recording-title']}>
                        <span className={'record-start-time'}>00:00</span>/<span
                            className={'record-end-time'}>24:00:00</span></div>
                </div>
            </div>
            <div className={s['record-list-footer-operate']}>
                <span className={s['record-operate-stop']}
                    style={recordStatus === RecordStatus.STOP_LOADING ? { cursor: 'not-allowed' } : {}}
                    onClick={() => stopRecordHandle({ callbackDetail: true })}>
                    {
                        recordStatus === RecordStatus.STOP_LOADING ? <SpinLoading
                            className={s['record-operate-loading']} style={{ '--size': '18px', '--color': '#c3c9d8' }}/> :
                            <img src={img.end_icon} />
                    }
                </span>
                <div className={s['record-list-footer-recording-img']}>{
                    recordStatus === RecordStatus.START ? <img width={24} src={recordPlay} alt={'record play'} /> :
                        <img width={30} src={recordPause} alt={'record pause'} />
                }</div>
               <span 
                    className={s['record-operate-start']}
                    style={
                        recordStatus === RecordStatus.LOADING 
                        || recordStatus === RecordStatus.STOP_LOADING 
                        || recordStatus === RecordStatus.STOP 
                        ? { cursor: 'not-allowed', pointerEvents: 'none' } 
                        : {}
                    }
                    onClick={
                        recordStatus === RecordStatus.STOP_LOADING 
                        ? () => {} 
                        : recordStatus === RecordStatus.PAUSE 
                        ? restartRecord 
                        : recordStatus === RecordStatus.START 
                            ? pauseRecord 
                            : () => {}
                    }
                    >
                    {
                        recordStatus === RecordStatus.LOADING ?
                        <SpinLoading className={s['record-operate-loading']} style={{ '--size': '18px', '--color': '#c3c9d8' }}/> 
                        : recordStatus === RecordStatus.STOP_LOADING || recordStatus === RecordStatus.STOP ?
                        <img width={30} src={img.play_icon} alt={'pause icon'} /> // 保持暂停后的播放图标
                        : recordStatus === RecordStatus.PAUSE ?
                        <img width={30} src={img.play_icon} alt={'pause icon'} />
                        :
                        <img width={30} src={img.pause_icon} />
                    }
                    </span>
                <audio style={{ display: "block" }} id={'audio'} />
                {/* <Button disabled={!recordObj?.blobData} onClick={playBackAudio}>播放录音</Button> */}
                {/* <Button disabled={!recordObj?.blobData} onClick={downLoadData}>下载录音</Button> */}
            </div>
        </div>
    }, [recordStatus, formData]);
    const recordListEle = useMemo(() => {
        return <div className={s['record-list']} id={'record-list'}>
            {msgList.map((ele, index) => <div key={ele.msg}
                className={s['record-list-item']}>
                <div
                    className={s['record-list-item-head']}>
                        {/* <img width={22} src={person4} alt={'发言人'} /> */}
                    <div className={s['record-list-item-head-img']}></div>&emsp;
                    <span>发言人</span>&emsp;
                    {ele.time ? Utils.formatTime(ele.time / 1000) : ''}
                </div>
                <div
                    className={s['record-list-item-content'] + ' ' + (index === msgList.length - 1 ? s['active'] : '')}>
                    <span>{ele.msg || ''}</span>
                </div>
            </div>)}
        </div>
    }, [msgList]);
    const callbackHandle = () => {
        changeLock(false);
        if (recordStatus !== RecordStatus.STOP && recordStatus !== RecordStatus.STOP_LOADING) return stopRecordHandle({ callbackList: true });
        navigate(`/mobile/o/${params?.agentId}/tools/${params?.toolId}`);
    }
    return <div className={s['ai-content-body']}>
        
        <div className={s['ai-content-body-header']}>
            <div className={s['ai-header-box']}>{started ? <HeadTitleOther /> : <HeadTitle />}</div>
        </div>
        {started ? <div className={s['record-content']}>
            {recordListEle}
            {recordingFooter}
        </div> : startRecordEle}
    </div>;
};
export default Record;
